/*
 * Copyright (c) 2026 Roboto Technologies, Inc.
 */
import * as React from "react";

import { AiCreditUsage } from "@/shared/domain/limits";

import { formatAiCreditUsage } from "./aiCreditFormatter";
import { UsageLimit } from "./UsageLimit";

export interface AiCreditUsageCardProps {
  usage: AiCreditUsage;
}

/**
 * Settings → Usage card showing the org's AI credit consumption for the
 * current week against the configured weekly cap. When the org's cap is the
 * "unlimited" sentinel, the card surfaces "Unlimited" copy instead of a
 * progress bar so users aren't shown a meaningless percentage.
 */
export const AiCreditUsageCard: React.FC<AiCreditUsageCardProps> = ({
  usage,
}) => {
  const { currentValue, limitValue, currentPercent } =
    formatAiCreditUsage(usage);

  return (
    <UsageLimit
      title="AI Credits (this week)"
      currentValue={currentValue}
      currentPercent={currentPercent}
      limitValue={limitValue}
      // UsageLimit's built-in period copy only knows "monthly" vs "total"; AI
      // credits reset weekly, so we opt out of that built-in copy and supply
      // the explicit weekly label instead. Both props together produce the
      // weekly framing — neither alone is enough.
      monthly={false}
      periodLabel="weekly"
    />
  );
};
